// extracted by mini-css-extract-plugin
export default {"toggle":"AudienceToggle_toggle__dN7Me","option":"AudienceToggle_option__XaTxz","optionActive":"AudienceToggle_optionActive__kAJlE"};